<section class="background-color-white">
    <div class="container booking">
        <h3 [innerHTML]="'booking.booking.person' | translate"></h3>
        <div *ngIf="showLoginForm$ | async" class="login-popup-btn">
            <p [innerHTML]="'booking.booking.login' | translate">If you already have an account, please log in.</p>
            <button class="secondary" (click)="openLoginPopup()" [innerHTML]="'booking.booking.loginBtn' | translate"></button>
        </div>

        <ng-container *ngIf="showLoginData$ | async">
            <div *ngIf="userData$ | async as user" class="contact-info">
                <div>
                    <div class="inner-wrapper">
                        <h4 [innerHTML]="'booking.booking.contact' | translate"></h4>
                        <span class="user-info"
                            ><strong
                                ><span *ngIf="user.salutation && user.salutation.code !== '' && user.salutation.code !== null">{{
                                    translatedSalutationUser
                                }}</span>
                                <span *ngIf="user.title">{{ user.title }}</span> <span>{{ user.firstName }}</span>
                                <span>{{ user.lastName }}</span></strong
                            ></span
                        >
                        <span>{{ user.email }}, {{ user.phoneCountry }}{{ user.phoneCity }}{{ user.phoneNumber }}</span>
                    </div>
                    <span  *ngIf="user.department">{{ user.department }}</span>
                    <div class="inner-wrapper">
                        <span
                            ><strong *ngIf="user.company && user.company.name">{{ user.company.name }}</strong>
                            <strong *ngIf="user.company && !user.company.name">{{ user.company }}</strong></span
                        >
                        <span class="user-info"
                            ><span>{{ user.address }},</span>{{ user.zipCode }} {{ user.city }}, <span *ngIf="user.regionKey && user.regionKey !== null && user.regionKey !== '' && user.country.code === 'BR'">{{ user.regionKey }},</span> {{ translatedCountryUser }}</span
                        >
                    </div>
                </div>
                <div class="inner-wrapper">
                    <a
                        da-link
                        [routerLink]="linkPersonalData"
                        [queryParams]="{ booking: true }"
                        [innerHTML]="'booking.booking.yourAccountLink' | translate"
                    ></a>
                </div>
            </div>
        </ng-container>
        <!-- <ng-template #loader>
            <section>
                <div id="loader-screen" class="drg-loading-container">
                    <i class="loading-icon"></i>
                    <i class="loader-shadow"></i>
                </div>
            </section>
        </ng-template> -->
        <ng-container *ngIf="(!(billingFormWasEdited$ | async) && !(loggedInUserShowBillingContactForm$| async)) && isLoggedIn">
            <ng-container>
                <div class="content">
                    <ng-container>
                        <div *ngIf="userData$ | async as user">
                            <h4 [innerHTML]="'booking.booking.billing' | translate"></h4>
                            <div class="inner-wrapper">
                                <span class="user-info"
                                    ><strong
                                        ><span *ngIf="user.billingContact.salutation && user.billingContact.salutation.code !== '' && user.billingContact.salutation.code !== null">{{
                                            translatedSalutationBilling
                                        }}</span>
                                        <span *ngIf="user.billingContact.title">{{ user.title }}</span> <span>{{ user.billingContact.firstName }}</span>
                                        <span>{{ user.billingContact.lastName }}</span></strong
                                    ></span
                                >
                                <span>{{ user.billingContact.email }}, {{ user.billingContact.phoneCountry }}{{ user.billingContact.phoneCity }}{{ user.billingContact.phoneNumber }}</span>
                            </div>
                            <span  *ngIf="user.billingContact.department">{{ user.billingContact.department }}</span>
                            <div class="inner-wrapper" *ngIf="user.company">
                                <span>
                                    <strong *ngIf="user.billingContact.company && user.billingContact.company.name">{{ user.billingContact.company.name }}</strong>
                                    <strong *ngIf="user.billingContact.company && !user.billingContact.company.name">{{ user.billingContact.company }}</strong>
                                </span>
                                <span class="user-info"
                                    ><span>{{ user.billingContact.address }},</span>{{ user.billingContact.zipCode }} {{ user.billingContact.city }}, <span *ngIf="user.billingContact.regionKey && user.billingContact.regionKey !== null && user.billingContact.regionKey !== '' && user.billingContact.country.code === 'BR'">{{ user.billingContact.regionKey }},</span>{{ translatedCountryBilling }}</span
                                >
                            </div>
                        </div>
                    </ng-container>
                    <div class="inner-wrapper" *ngIf="billingContact$ | async as user">
                        <a da-link (click)="showBillingContactFormClick()" [innerHTML]="'booking.booking.yourBillingLink' | translate"></a>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <form [formGroup]="booking">
            <div *ngIf="showLoginForm$ | async">
                <da-person-form
                    formControlName="person"
                    [formTitle]="'booking.booking.contact' | translate"
                    [events]="eventsSubject.asObservable()"
                    [isBookingPerson]="false"
                    [stepNum]="1"
                    (preselectCountryCode)="preselectCountry($event)"
                ></da-person-form>
            </div>
            <ng-container>
                <div class="billing-contact" *ngIf="(((billingFormWasEdited$ | async) || !isLoggedIn)) || ((loggedInUserShowBillingContactForm$ | async) && isLoggedIn)"[ngClass]="{ 'billing-contact-hidden': (!(billingFormWasEdited$ | async) && !isLoggedIn && site !== 'de_de') }"
                >
                    <h4 [innerHTML]="'booking.booking.billing' | translate"></h4>
                    <div
                    *ngIf="showSameAsBookingContactCheckbox"
                    class="data-group full-width"
                        [ngClass]="{ 'no-form': !showBillingContactForm}"
                    >
                        <div class="group checkbox" [ngClass]="{ edit: showBillingContactForm && !(showLoginForm$ | async)}">
                            <label class="checkboxlabel">
                                <input
                                    type="checkbox"
                                    id="sameAsBookingContact"
                                    formControlName="sameAsBookingContact"
                                    (change)="sameAsBookingContact($event.target.checked)"
                                />
                                <label
                                    for="sameAsBookingContact"
                                    class="subscribe-me"
                                    [innerHTML]="'booking.bookingParticipants.sameAs' | translate"
                                ></label>
                            </label>
                        </div>
                    </div>
                    <div *ngIf="(showBillingContactForm && (billingFormWasEdited$ | async) && showBilling) || ((showBillingContactForm || (billingFormWasEdited$ | async)) && isLoggedIn) || (((!showBillingContactForm || !(billingFormWasEdited$ | async)) && site === 'de_de') && !isLoggedIn) ">
                        <da-person-form
                            (sameAs)="sameAs($event)"
                            formControlName="billing"
                            [formTitle]=""
                            [index]="1"
                            [hideSameAsCompany]="!showSameAsBookingContactCheckbox"
                            [events]="eventsSubject.asObservable()"
                            [isBookingPerson]="true"
                            [isBillingContact]="true"
                            [stepNum]="1"
                            (preselectCountryCode)="preselectCountry($event)"
                        ></da-person-form>
                    </div>
                </div>
            </ng-container>

            <div class="additional-info-wrapper">
                <h4 [innerHTML]="'booking.booking.additionalInfo' | translate"></h4>
                <div class="inner-wrapper">
                    <div
                        class="form-group"
                        [class.active]="hasPONumber || hasValue(f.number)"
                        [class.hasvalue]="!hasPONumber && hasValue(f.number)"
                    >
                        <label
                            for="number"
                            [class.active]="hasPONumber || hasValue(f.number)"
                            [class.hasvalue]="!hasPONumber && hasValue(f.number)"
                        >
                            <span class="labelcontent"><span [innerHTML]="'booking.booking.number' | translate"></span></span>
                            <input
                                formControlName="number"
                                id="number"
                                (focus)="hasPONumber = true"
                                (blur)="hasPONumber = false"
                                type="text"
                                maxlength="50"
                            />
                        </label>
                        <div *ngIf="submitted && f.number.errors" class="invalid-feedback">
                            <div *ngIf="f.number.errors.pattern" [innerHTML]="'booking.booking.invalidFieldFormat' | translate"></div>
                            <div *ngIf="f.number.errors.maxLength" [innerHTML]="'booking.booking.reachedMaxLength' | translate"></div>
                        </div>
                    </div>
                    <div>&nbsp;</div>
                </div>
                <div
                    class="form-group"
                    [class.active]="hasFocusNote || hasValue(f.note)"
                    [class.hasvalue]="!hasFocusNote && hasValue(f.note)"
                >
                    <label
                        for="note"
                        [class.active]="hasFocusNote || hasValue(f.note)"
                        [class.hasvalue]="!hasFocusNote && hasValue(f.note)"
                    >
                        <span class="labelcontent"><span [innerHTML]="'booking.booking.note' | translate"></span></span>
                        <div class="textareacontainer">
                            <textarea
                                autosize
                                id="note"
                                formControlName="note"
                                (focus)="hasFocusNote = true"
                                (blur)="hasFocusNote = false"
                                rows="3"
                                maxlength="250"
                            ></textarea>
                        </div>
                    </label>
                    <div *ngIf="submitted && f.note.errors" class="invalid-feedback">
                        <div *ngIf="f.note.errors.pattern" [innerHTML]="'booking.booking.invalidFieldFormat' | translate"></div>
                        <div *ngIf="f.note.errors.maxLength" [innerHTML]="'booking.booking.reachedMaxLength' | translate"></div>
                    </div>
                </div>

                <div
                    *ngIf="countryInfo1Key && countryInfo1Label"
                    class="form-group"
                    [class.active]="hasFocusCountryInfo1 || hasValue(f.countryInfo1Value)"
                    [class.hasvalue]="!hasFocusCountryInfo1 && hasValue(f.countryInfo1Value)"
                >
                    <label
                        for="note"
                        [class.active]="hasFocusCountryInfo1 || hasValue(f.countryInfo1Value)"
                        [class.hasvalue]="!hasFocusCountryInfo1 && hasValue(f.countryInfo1Value)"
                    >
                        <span class="labelcontent"><span [innerHTML]="countryInfo1Label"></span></span>
                        <div class="textareacontainer">
                            <textarea
                                autosize
                                id="countryInfo1"
                                formControlName="countryInfo1Value"
                                (focus)="hasFocusCountryInfo1 = true"
                                (blur)="hasFocusCountryInfo1 = false"
                                rows="3"
                            ></textarea>
                        </div>
                    </label>
                    <div *ngIf="submitted && f.countryInfo1Value.errors" class="invalid-feedback">
                        <div *ngIf="f.countryInfo1Value.errors.pattern" [innerHTML]="'booking.booking.invalidFieldFormat' | translate"></div>
                    </div>
                </div>
                <div
                    *ngIf="countryInfo2Key && countryInfo2Label"
                    class="form-group"
                    [class.active]="hasFocusCountryInfo2 || hasValue(f.countryInfo2Value)"
                    [class.hasvalue]="!hasFocusCountryInfo2 && hasValue(f.countryInfo2Value)"
                >
                    <label
                        for="note"
                        [class.active]="hasFocusCountryInfo2 || hasValue(f.countryInfo2Value)"
                        [class.hasvalue]="!hasFocusCountryInfo2 && hasValue(f.countryInfo2Value)"
                    >
                        <span class="labelcontent"><span [innerHTML]="countryInfo2Label"></span></span>
                        <div class="textareacontainer">
                            <textarea
                                autosize
                                id="countryInfo2"
                                formControlName="countryInfo2Value"
                                (focus)="hasFocusCountryInfo2 = true"
                                (blur)="hasFocusCountryInfo2 = false"
                                rows="3"
                            ></textarea>
                        </div>
                    </label>
                    <div *ngIf="submitted && f.countryInfo2Value.errors" class="invalid-feedback">
                        <div *ngIf="f.countryInfo2Value.errors.pattern" [innerHTML]="'booking.booking.invalidFieldFormat' | translate"></div>
                    </div>
                </div>

            </div>
        </form>
        <span class="required" *ngIf="!(showLogin$ | async)" [innerHTML]="'booking.booking.required' | translate"></span>
        <div class="button-wrapper" *ngIf="!(loading$ | async)">
            <a da-link class="button secondary" (click)="goToStep(0)" [innerHTML]="'booking.booking.back' | translate"></a>
            <a da-link class="button primary" (click)="goToStep(2)" [innerHTML]="'booking.booking.toTheParticipants' | translate"></a>
        </div>
        <div class="button-wrapper" *ngIf="(loading$ | async)">
            <div id="loader-screen" class="drg-loading-container">
                <i class="loading-icon"></i>
                <i class="loader-shadow"></i>
            </div>
        </div>
    </div>
</section>

<!-- <div class="notification" *ngIf="loginPopupShow$ | async as showLoginPopup">
    <div class="modal">
        <div class="location-popup">Test</div>
    </div>
</div> -->

<ng-template #loginPopupShow>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="location"></ng-container>
    </div>
</ng-template>
<ng-template #location>
    <div class="location-popup">
        <da-login-popup (closePopup)="closeModal()"> </da-login-popup>
    </div>
</ng-template>
